import React from 'react';
import type { OrderSummaryData } from '../../../types';
import { useCouponManagement } from '../hooks/useCouponManagement';
import { CouponInput } from './CouponInput';
import { CouponMessages } from './CouponMessages';

interface CouponSectionProps {
  summary: OrderSummaryData;
  onApplyCoupon: (couponCode: string) => Promise<void>;
  couponError?: string;
  isLoading?: boolean;
}

export const CouponSection: React.FC<CouponSectionProps> = ({
  summary,
  onApplyCoupon,
  couponError,
  isLoading = false,
}) => {
  const {
    couponInput,
    showRemovedMessage,
    localCouponError,
    couponApplied,
    handleApplyCoupon,
    handleRemoveCoupon,
    setCouponInput,
  } = useCouponManagement(summary, onApplyCoupon);

  return (
    <div>
      <label htmlFor="coupon" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
        Tem um cupom?
      </label>
      
      <CouponInput
        couponInput={couponInput}
        setCouponInput={setCouponInput}
        couponApplied={couponApplied}
        showRemovedMessage={showRemovedMessage}
        couponError={couponError}
        isLoading={isLoading}
        onApplyCoupon={handleApplyCoupon}
      />

      <CouponMessages
        couponError={couponError}
        localCouponError={localCouponError}
        showRemovedMessage={showRemovedMessage}
        couponApplied={couponApplied}
        onRemoveCoupon={handleRemoveCoupon}
      />
    </div>
  );
}; 